import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { Meeting, MeetingsService } from '../meetings.service'
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component'
import { ToastService } from '../toast.service'
import { ActivatedRoute } from '@angular/router'
import { combineLatest } from 'rxjs'
import { AsyncPipe } from '@angular/common'
import { SpinnerComponent } from '../spinner/spinner.component'

@Component({
  selector: 'app-meeting-access-request-approve-page',
  standalone: true,
  imports: [AsyncPipe, TranslatePipe, SpinnerComponent],
  templateUrl: './meeting-access-request-approve-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './meeting-access-request-approve-page.component.scss',
})
export class MeetingAccessRequestApprovePageComponent implements OnInit {
  meetingsService = inject(MeetingsService)
  toastService = inject(ToastService)
  dialog = inject(MatDialog)
  translateService = inject(TranslateService)
  route = inject(ActivatedRoute)
  meetingId = parseInt(this.route.snapshot.params['id'], 10)
  accessRequest$ = this.meetingsService.getMeetingAccessRequest(this.meetingId)
  meeting$ = this.meetingsService.getMeeting(this.meetingId)
  approveAccessRequestMutation = this.meetingsService.approveAccessRequest()
  grantedNow = false

  ngOnInit() {
    combineLatest([this.accessRequest$, this.meeting$]).subscribe(([accessRequestResult, meetingResult]) => {
      if (meetingResult.isSuccess && accessRequestResult.isSuccess && !accessRequestResult.data.accessProvided) {
        this.openAccessRequestGrantDialog(meetingResult.data!)
      }
    })
  }

  async openAccessRequestGrantDialog(meeting: Meeting) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: this.translateService.instant('MEETINGS.ACCESS_REQUEST.APPROVE_DIALOG_TITLE'),
        description: this.translateService.instant('MEETINGS.ACCESS_REQUEST.APPROVE_DIALOG_DESCRIPTION', { meetingName: meeting.name }),
        descriptionClass: 'mask-meeting-name',
      },
    })
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          await this.approveAccessRequestMutation.mutateAsync(this.meetingId)
          this.grantedNow = true
          this.toastService.show('MEETINGS.ACCESS_REQUEST.SUCCESS')
        } catch (error) {
          this.toastService.show('MEETINGS.ACCESS_REQUEST.FAILURE')
        }
      }
    })
  }
}
